import { Request } from '~src/httpClient/serverApi/requests/Request';

import { ITaskDetailsResult } from '../types/ITaskDetails';

export interface IGetTaskDetailsParams {
  taskLuid: string;
}

/**
 * `getTaskDetails` request (S05-b). Returns the task metadata + aggregates for the
 * Task Details page. Contract frozen in `contract-freeze-s03-s04-s06-for-frontend.md`.
 */
export class GetTaskDetailsRequest extends Request<IGetTaskDetailsParams, ITaskDetailsResult> {
  constructor(params: IGetTaskDetailsParams) {
    super('getTaskDetails', params);
  }
}
